export const services_zh = [
    {
        image: "1",
        alt: "税务相关",
        title: "东南亚商业分析",
        description: "我们的团队利用先进的数据分析工具和本地网络来评估南亚的商业环境。我们提供的服务包括市场进入策略、行业趋势、竞争分析、法规合规性和风险管理。WIT Consulting 提供量身定制的解决方案，以确保基于可靠数据和市场洞察力的明智商业决策。",
    },
    {
        image: "2",
        alt: "南亚投资风险评估",
        title: "南亚投资风险评估",
        description: "我们拥有一支专业团队来评估投资风险，包括政治风险、经济波动、法律变更等更多方面。我们提供风险识别和缓解策略，以及投资建议，以保护客户的资产并实现收益最大化。",
    },
    {
        image: "3",
        alt: "深入的区域政策研究",
        title: "深入的区域政策研究",
        description: "我们分析国际和区域政策对南亚经济和商业环境的影响，重点关注像南亚区域合作联盟（SAARC）这样的经济合作组织。通过前瞻性的政策洞察，我们帮助客户把握政策变化带来的机遇和挑战，确保他们的商业战略与区域发展保持一致。",
    },
    {
        image: "4",
        alt: "南亚地缘政治分析",
        title: "南亚地缘政治分析",
        description: "我们分析南亚国家之间的政治和经济互动，涵盖边界争端、经济协议以及地缘政治影响。WIT咨询帮助客户理解区域和外部政治动态，为他们的战略决策提供坚实的分析支持。"
    }
]